import { createQueryKeys } from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { RequestTypes } from './requestTypes'

export const inspectionTemplatesKeys = createQueryKeys('inspectionTemplates', {
  list: ({ projectId, ...params }: RequestTypes['getInspectionTemplates']) => {
    return {
      queryKey: [projectId, params],
      queryFn: async () => {
        const { data } = await APIAxiosInstance.get(
          `projects/${projectId}/inspection-templates${createQueryKeyString(
            params,
          )}`,
        )
        return data
      },
    }
  },
})
